import { api } from "./apiClient";

export const safetyAPI = {
    listByProject: (projectId) =>
        api.get(`/projects/${projectId}/safety`),

    create: (projectId, payload) =>
        api.post(`/projects/${projectId}/safety`, payload),
};
